import styled, { css } from 'styled-components'
import { ActiveSearchHelpStatus } from 'common/enum/active-search-help-status'

type HelpStatus = {
  status: ActiveSearchHelpStatus
}

type BoxDefaultProps = {
  lineClamp?: boolean
}

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Filters = styled.form`
  display: flex;
  align-items: center;
  gap: 24px;
  flex-wrap: wrap;
  width: 100%;
  margin-bottom: 32px;

  .inputs {
    flex: 3;
    min-width: 250px;
  }

  .actions {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 16px;
  }
`

export const BoxDefault = styled.span<BoxDefaultProps>`
  ${({ lineClamp }) => css`
    display: block;
    width: fit-content;
    text-align: left;
    white-space: pre-wrap;
    word-wrap: break-word;
    /* word-break: break-all; */
    line-height: 1.3;

    ${lineClamp &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  `}
`

export const BoxDefaultCentered = styled.span<BoxDefaultProps>`
  ${({ lineClamp }) => css`
    display: block;
    width: fit-content;
    text-align: center;
    margin: 0 auto;
    line-height: 1.3;
    word-wrap: break-word;
    white-space: pre-wrap;

    ${lineClamp &&
    css`
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
      text-overflow: ellipsis;
    `}
  `}
`

export const HelpStatusBadge = styled.div<HelpStatus>`
  ${({ theme, status }) => css`
    padding: 4px 8px;
    border-radius: 16px;
    font-weight: ${theme.ds.typography.weight.semiBold};
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 8px;
    gap: 4px;
    width: fit-content;
    background-color: ${theme.ds.colors.terciary100};

    /* > .number {
      line-height: 21px;
      font-weight: ${theme.ds.typography.weight.semiBold};
      color: ${theme.ds.colors.terciary900};
      font-size: ${theme.ds.typography.size.small};
    } */

    > .icon {
      width: 21px;
      height: 21px;

      path {
        fill: ${theme.ds.colors.terciary500};
      }
    }

    ${status === ActiveSearchHelpStatus.IN_PROGRESS &&
    css`
      background-color: ${theme.ds.colors.secondary100};

      /* > .number {
        color: ${theme.ds.colors.secondary900};
      } */

      > .icon {
        path {
          fill: ${theme.ds.colors.secondary500};
        }
      }
    `}

    ${status === ActiveSearchHelpStatus.RESOLVED &&
    css`
      background-color: ${theme.ds.colors.primary100};

      /* > .number {
        color: ${theme.ds.colors.primary900};
      } */

      > .icon {
        path {
          fill: ${theme.ds.colors.primary600};
        }
      }
    `}
  `}
`
